import React, { memo, useState, useContext, useEffect, useRef } from "react";

import { Box, Button, Divider } from "@mui/material";

import Tabla from "./Componentes/Tabla";

import clienteAxios from "../../../config/axios";
import AlertaContext from "../../../Context/Alerta/AlertaContext";
import AuthContext from "../../../Context/Auth/AuthContext";
import Modal from "./Componentes/Modal";
import io from "socket.io-client";
import { socketUrl } from "../../../config/const";

import { Add, Search } from "@mui/icons-material";
import { usePermiso } from "../../../hooks/usePermiso";
import { useCrud } from "../../../hooks/useCrud";
// COLUMNAS
import { columns, objectDefault } from "./data";

import BarraTablas from "../../components/Tablas/BarraTablas";
import ModalB from "../../components/Modal/ModalB";
import DialogOpciones from "../../components/Dialogs/DialogOpciones";
import { Calendar } from "react-big-calendar";
import { getMessages, localizer } from "../../Veterinaria/Reservas/helpers";
import { CalendarEvent } from "./Componentes/CalendarEvent";
import {
  addDays,
  endOfMonth,
  endOfWeek,
  startOfMonth,
  startOfWeek,
} from "date-fns";
import { useTheme } from "@emotion/react";
const CalendarioHorarios = ({ idPer_frompersonas }) => {
  // DATA DEL STATE
  // REGISTROS O FILAS
  const [rows, setrows] = useState([]);

  // FUNCION QUE CREA EL OBJETO BUSCADOR
  const defaultFullBuscador = () => {
    const json = {};
    columns.forEach((itemPropiedad) => {
      Object.entries({ itemPropiedad }).forEach((item) => {
        if (item.ocultar) {
          return;
        }
        if (itemPropiedad.tipo === "string") {
          json[`${item[1].propiedad}`] = "";
        } else if (itemPropiedad.tipo === "numero") {
          json[`${item[1].propiedad}1`] = "";
          json[`${item[1].propiedad}2`] = "";
        } else if (itemPropiedad.tipo === "fecha") {
          json[`${item[1].propiedad}1`] = "";
          json[`${item[1].propiedad}2`] = "";
        }
      });
    });
    return json;
  };
  // OBJETO ACTIVO O PLANTILLA
  const [ObjectoActivo, setObjetoActivo] = useState(objectDefault);
  const [eliminado, seteliminado] = useState(false);
  // PAGINACION
  const [pagination, setpagination] = useState(null);
  // FUNCIONES STATE
  // FUNCION QUE OBTIENE LA DATA DE LA TABLA

  const [mes, setmes] = useState(
    `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(
      2,
      "0"
    )}`
  );
  const [fechas, setFechas] = useState({
    fecha_inicio: "",
    fecha_fin: "",
  });
  const getDataState = async (
    cantidad,
    page,
    search,
    input,
    orden,
    datos,
    rucempresa,
    estado,
    eliminado
  ) => {
    try {
      setcargando(true);

      const res = await clienteAxios.post(`/horarios/por_mes`, {
        ...fechas,
        search,
      });
      console.log({ res });
      setrows(
        res.data.map((event) => ({
          ...event,
          desde: event.desde ? new Date(event.desde) : null,
          hasta: event.hasta ? new Date(event.hasta) : null,
        }))
      );

      setcargando(false);
    } catch (error) {
      setdataCalendar([]);
      setcargando(false);
    }
  };
  // FUNCION QUE COLOCA LA DATA EN EL STATE
  const obtenerState = async (
    cantidad = 10,
    page = 0,
    search,
    input,
    orden,
    datos,
    rucempresa,
    estadoRequest,
    eliminado
  ) => {
    try {
      const res = await getDataState(
        cantidad,
        page,
        search,
        input,
        orden,
        datos,
        rucempresa,
        estadoRequest,
        eliminado
      );
      console.log(res);

      setrows(
        res.data.map((event) => ({
          ...event,
          desde: event.desde ? new Date(event.desde) : null,
          hasta: event.hasta ? new Date(event.hasta) : null,
        }))
      );
      // setpagination(res.data.data.pagination);
    } catch (error) {}
  };
  // AGREGA MAS REGISTROS AL STATE
  const addRowsState = async (items) => {
    setrows([...rows, ...items]);
  };
  // REMPLAZA LA CONSULTA ACTUAL POR UNA NUEVA CON OTROS PARAMETROS
  const remplazarRowsState = async (
    cantidad,
    page,
    search,
    input,
    orden,
    datos,
    rucempresa,
    estadoRequest
  ) => {
    const res = await getDataState(
      cantidad,
      page,
      search,
      input,
      orden,
      datos,
      rucempresa,
      estadoRequest,
      eliminado
    );
  };
  // CAMBIA EL OBJETO ACTIVO DEL STATE GENERALMENTE PARA EDITAR
  const changeObjetoActivoState = (item) => {
    setObjetoActivo(item);
  };

  // FIN FUNCIONES STATE
  // FIN DATA STATE

  // FUNCIONES SOCKET
  // NOMBRE DE LA TABLA
  const [tabla] = useState("new_horarios");
  // ITEM DEL SOCKET SE UTILIZA COMO REFERENCIA
  const [itemSocket, setitemSocket] = useState({
    tipo: "",
    item: {},
  });
  // REFERENCIA DEL SOCKET
  const socket = useRef();
  // USEFFECT QUE ESCUCHUA LOS EVENTOS DEL SOCKET
  useEffect(() => {
    // Creates a WebSocket connection
    socket.current = io(socketUrl);
    socket.current.on("server:guardadoExitoso", (data) => {
      if (data.tabla !== tabla) {
        return;
      }
      console.log({ data });

      setitemSocket({
        tipo: "agregar",
        item: data,
      });
    });
    socket.current.on("server:actualizadoExitoso", (data) => {
      if (data.tabla !== tabla) {
        return;
      }
      setitemSocket({
        tipo: "editar",
        item: data,
      });
    });
    socket.current.on("server:eliminadoExitoso", (data) => {
      if (data.tabla !== tabla) {
        return;
      }
      setitemSocket({
        tipo: "eliminar",
        item: data,
      });
    });
    socket.current.on("server:eliminadoExitosoSeleccionado", (data) => {
      if (data.tabla !== tabla) {
        return;
      }
      setitemSocket({
        tipo: "eliminarSeleccion",
        item: data,
      });
    });

    socket.current.on("server:error", (data) => {
      mostrarAlerta(
        data.msg ? data.msg : "Hubo un error",
        data.alert ? data.alert : "error"
      );
    });
    return () => {
      socket.current.disconnect();
    };

    // Destroys the socket reference
    // when the connection is closed
    // eslint-disable-next-line
  }, []);
  // CUANDO CAMBIA EL OBJETO DEL SOCKET SE ESCUCHA AQUI Y SE DECIDE QUE HACER CON EL
  useEffect(() => {
    const { item, tipo } = itemSocket;

    if (tipo === "") {
      return;
    }
    if (!rows) {
      return;
    }
    if (usuario.rucempresa !== item.rucempresa) {
      return;
    }
    if (item.tabla !== tabla) {
      return;
    }

    const funcionAalerta = () => {
      if (item.msg === "") {
        return null;
      }
      if (!item.msg) {
        return null;
      }
      mostrarAlerta(item.msg, item.alert ? item.alert : "success");
    };

    console.log(item.fechas, { tipo, item, rows });
    if (tipo === "agregar") {
      setrows([
        ...rows,
        ...item.fechas.map((event) => ({
          ...event,
          desde: event.desde ? new Date(event.desde) : null,
          hasta: event.hasta ? new Date(event.hasta) : null,
        })),
      ]);
    }
    if (tipo === "editar") {
      setrows([
        ...rows.filter(
          (row) => !item.fechas.some((fecha) => fecha.dht_id === row.dht_id)
        ),
        ...item.fechas.map((event) => ({
          ...event,
          desde: event.desde ? new Date(event.desde) : null,
          hasta: event.hasta ? new Date(event.hasta) : null,
        })),
      ]);
    }
    if (tipo === "eliminar") {
      eliminarState(item[campoExport]);
    }
    if (tipo === "eliminarSeleccion") {
      eliminarSeleccionState(item.lista);
    }
    funcionAalerta();
    setitemSocket({ tipo: "", item: {} });
    // eslint-disable-next-line
  }, [itemSocket]);
  const { mostrarAlerta } = useContext(AlertaContext);
  const {
    usuario: { rucempresa },
    usuario,
  } = useContext(AuthContext);
  // HOOK DE PERMISO
  const { tienePermiso, alertaPermiso } = usePermiso("CalendarioHorarios");
  const [estadoRequest, setestadoRequest] = useState(
    idPer_frompersonas ? "PROCESADOS" : "PENDIENTES"
  );
  // ABRIR MODAL
  const [open, setopen] = useState(false);
  // BOOLEANO DE SI SE ESTA BUSCANDO O NO
  const [buscando, setbuscando] = useState(false);
  // SI SE ESTA EDITANDO O NO
  const [editar, seteditar] = useState(false);
  // STRING DE BUSQUEDA
  const [search, setsearch] = useState("");
  // BOOLEANO DE SI ESTA CARGANDO
  const [cargando, setcargando] = useState(false);
  // CAMPO POR EL CUAL SE FILTRAN LOS REGISTROS PARA EXPORTAR
  const [campoExport] = useState("h_id");
  // HOOK PARA FUNCIONES DEL CRUD
  const {
    agregarState,
    editarState,
    eliminarState,
    eliminarSeleccionState,
  } = useCrud(rows, setrows, campoExport, "h_usuario", usuario);
  // ORDEN DE POR DEFECTO
  const [input, setinput] = useState({
    id: "h_id",
    label: "ID",
    minWidth: 150,
    tipo: "string",
    propiedad: "h_id",
  });
  // ARRAY DE EXPORTACION
  const [arrayExport, setarrayExport] = useState([]);
  // BOLLEANO DE SI ESTA ABIERTO EL DIALOG DE OPCIONES
  const [openDialogOpciones, setopenDialogOpciones] = useState(false);
  // ORDEN ASCENDENTE O DESCENDENTE
  const [orden, setorden] = useState(false);
  // CAMPOS DE BUSQUEDA EXPANDIDOS
  const [openMB, setopenMB] = useState(false);
  // OBJETO BUSCADOR
  const [fullBuscador, setfullBuscador] = useState(defaultFullBuscador());

  //pagina actual
  const [page, setPage] = React.useState(0);
  //filas por pagina
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  // EVENTO QUE CAMBIA LA DATA DEL OBJETO BUSCADOR
  const handleChange = (e) => {
    setfullBuscador({ ...fullBuscador, [e.target.name]: e.target.value });
  };
  // FUNCION DE BUSQUEDA AVANZADA
  const funcionB = async () => {
    setcargando(true);
    await remplazarRowsState(
      rowsPerPage,
      0,
      search,
      input.id,
      orden,
      JSON.stringify(fullBuscador),
      rucempresa,
      estadoRequest
    );
    setPage(0);
    setbuscando(true);
    setopenMB(false);
    setcargando(false);
  };
  // FUNCION DE BUSQUEDA RAPIDA
  const handleSearch = async () => {
    setarrayExport([]);
    setcargando(true);
    setbuscando(true);
    await remplazarRowsState(
      rowsPerPage,
      0,
      search,
      input.id,
      orden,
      JSON.stringify(fullBuscador),
      rucempresa,
      estadoRequest
    );

    setPage(0);
    setcargando(false);
  };
  // FUNCION QUE PONE LA DATA DE POR DEFECTO O HACE UN REFRESH
  const funcionDefault = async () => {
    setcargando(true);
    const fullBRes = defaultFullBuscador();
    setfullBuscador(fullBRes);
    await remplazarRowsState(
      rowsPerPage,
      0,
      "",
      input.id,
      orden,
      JSON.stringify(fullBRes),
      rucempresa,
      estadoRequest
    );

    setPage(0);
    setsearch("");
    setbuscando(false);
    setcargando(false);
    setopenMB(false);
  };

  const [dataCalendar, setdataCalendar] = useState([]);
  const [lastView, setlastView] = useState(
    localStorage.getItem("lastView") || "week"
  );
  const theme = useTheme();
  const eventStyleGetter = (event, start, end, isSelected) => {
    const style = {
      // backgroundImage: `linear-gradient(to right, ${event.dht_color}, #e52e71)`,
      backgroundColor: event.dht_color,
      borderRadius: "0px",
      color: theme.palette.getContrastText(event.dht_color),
    };
    return { style };
  };

  const onDoubleClick = async (event) => {
    const res = await clienteAxios.get(
      `horarios/${event.dht_id_horario}/por_id_horario_padre`
    );
    console.log({ res });

    seteditar(true);
    changeObjetoActivoState({
      ...res.data[0],
      fechas: res.data[0].fechas.map((event) => ({
        ...event,
        desde: event.desde ? new Date(event.desde) : null,
        hasta: event.hasta ? new Date(event.hasta) : null,
      })),
    });
    setopen(true);
  };
  const onSelect = (event) => {
    console.log(event);
  };
  const onViewChange = (event) => {
    setlastView(event);
    localStorage.setItem("lastView", event);
  };
  // const handleSelectSlot = (slotInfo) => {
  //   // slotInfo.start y slotInfo.end son objetos Date
  //   const nuevoEvento = {
  //     desde: slotInfo.start,
  //     hasta: slotInfo.end || slotInfo.start,
  //     // Puedes agregar más propiedades si lo necesitas
  //   };
  //   setrows((prevRows) => [...prevRows, nuevoEvento]);
  //   console.log("Evento agregado:", nuevoEvento);
  // };

  const onLoadCurrentViewDates = async () => {
    const thisDate = new Date();
    const fecha_inicio = addDays(startOfMonth(thisDate), -6);
    const fecha_fin = addDays(endOfMonth(thisDate), 6);

    try {
      setcargando(true);
      setFechas({
        fecha_inicio: fecha_inicio.toISOString().substring(0, 10),
        fecha_fin: fecha_fin.toISOString().substring(0, 10),
      });
      const res = await clienteAxios.post(`/horarios/por_mes`, {
        fecha_inicio: fecha_inicio.toISOString().substring(0, 10),
        fecha_fin: fecha_fin.toISOString().substring(0, 10),
        search,
      });
      console.log({ res });
      setrows(
        res.data.map((event) => ({
          ...event,
          desde: event.desde ? new Date(event.desde) : null,
          hasta: event.hasta ? new Date(event.hasta) : null,
        }))
      );

      setcargando(false);
    } catch (error) {
      setdataCalendar([]);
      setcargando(false);
    }
  };
  useEffect(() => {
    onLoadCurrentViewDates();
    // eslint-disable-next-line
  }, []);
  // useEffect(() => {
  //   obtenerState(
  //     10,
  //     0,
  //     search,
  //     input.id,
  //     orden,
  //     JSON.stringify(fullBuscador),
  //     rucempresa,
  //     estadoRequest
  //   );
  //   // eslint-disable-next-line
  // }, []);
  return (
    <Box sx={{ width: "100%", color: "black" }}>
      <BarraTablas
        search={search}
        setsearch={setsearch}
        funcion={handleSearch}
        buscando={buscando}
        setbuscando={setbuscando}
        LabelBuscador="Buscar Por: Nombre"
        funcionDefault={funcionDefault}
        ocultarMigasDePan={idPer_frompersonas}
        botones={[
          {
            tooltip: "Agregar",
            texto: "Agregar",
            funcion: () => {
              setopen(true);
            },
            disabled: false,
            Icon: Add,
            color: "primary",
            id: 1,
            ocultar: true,
            tipo: "icono",
            variante: "contained",
            size: "medium",
            sx: { marginRight: ".3rem" },
          },
          {
            tooltip: "Agregar",
            texto: "Agregar",
            funcion: () => {
              if (!tienePermiso("agregar")) {
                return alertaPermiso("agregar");
              }
              setopen(true);
            },
            disabled: false,
            Icon: Add,
            color: "primary",
            id: 2,
            ocultar: false,
            tipo: "boton",
            variante: "contained",
            size: "medium",
            sx: {},
          },
          {
            tooltip: "Buscar",
            texto: "",
            funcion: () => {
              setopenMB(true);
            },
            disabled: false,
            Icon: Search,
            color: "secondary",
            id: 2,
            ocultar: true,
            tipo: "icono",
            variante: "contained",
            size: "medium",
            sx: {},
          },
        ]}
      />
      {socket.current && (
        <Modal
          editar={editar}
          seteditar={seteditar}
          setopen={setopen}
          open={open}
          ObjectoActivo={ObjectoActivo}
          changeObjetoActivoState={changeObjetoActivoState}
          socket={socket}
        />
      )}

      <Calendar
        toolbar={true}
        culture="es"
        localizer={localizer}
        events={rows}
        defaultView={lastView}
        style={{ height: "80vh", color: "black" }}
        startAccessor="desde"
        endAccessor="hasta"
        view={lastView}
        messages={getMessages()}
        eventPropGetter={eventStyleGetter}
        components={{
          event: (event) => (
            <CalendarEvent
              event={event}
              showPdf
              // changeObjetoActivoStatePropietario={
              //   changeObjetoActivoStatePropietario
              // }
              // setopenPropietarioModal={setopenPropietarioModal}
              // setopenConfirmDialog={setopenConfirmDialog}
            />
          ),
        }}
        onDoubleClickEvent={onDoubleClick}
        // onSelectEvent={onSelect}
        onView={onViewChange}
        // selectable={true} //
        // onSelectSlot={handleSelectSlot}
        onRangeChange={async (fechas, tipo) => {
          setcargando(true);

          let fecha_inicio = new Date();
          let fecha_fin = new Date();

          if (fechas.start && fechas.end) {
            fecha_inicio = new Date(fechas.start);
            fecha_fin = new Date(fechas.end);
          } else if (Array.isArray(fechas) && fechas.length > 0) {
            fecha_inicio = new Date(fechas[0]);
            fecha_fin = new Date(fechas[fechas.length - 1]);
          }
          setFechas(fecha_fin);
          console.log({ fecha_inicio, fecha_fin });

          try {
            const res = await clienteAxios.post(`/horarios/por_mes`, {
              fecha_inicio: fecha_inicio.toISOString().substring(0, 10),
              fecha_fin: fecha_fin.toISOString().substring(0, 10),
              search: search,
            });
            console.log({ res });
            setFechas({
              fecha_inicio: fecha_inicio.toISOString().substring(0, 10),
              fecha_fin: fecha_fin.toISOString().substring(0, 10),
            });
            setrows(
              res.data.map((event) => ({
                ...event,
                desde: event.desde ? new Date(event.desde) : null,
                hasta: event.hasta ? new Date(event.hasta) : null,
              }))
            );
          } catch (error) {
            console.error("Error al cargar horarios:", error);
          }
          // let url = `reservas/toCalendar?tipo=${
          //   fechas.length === 1 ? "day" : "month"
          // }&fechas=${JSON.stringify(fechas)}&eliminado=${eliminado}`;
          // if (fechas.length === 7) {
          //   url = `reservas/toCalendar?tipo=${"week"}&fechas=${JSON.stringify([
          //     ...fechas,
          //     addDays(fechas[6], 1),
          //   ])}&eliminado=${eliminado}`;
          // }
          // const res = await clienteAxios.get(url);

          // setdataCalendar([
          //   ...res.data.data.map((reserva) => ({
          //     ...reserva,
          //     start: new Date(reserva.resFecha),
          //     end: new Date(reserva.
          //   })),
          // ]);
          setcargando(false);
        }}
      />
    </Box>
  );
};

export default memo(CalendarioHorarios);

//  <DialogOpciones
//       open={openDialogOpciones}
//       setopen={setopenDialogOpciones}
//       botones={[
//         {
//           tooltip: "Agregar",
//           funcion: () => {
//             setopen(true);
//           },
//           Icon: Add,
//           color: "primary",
//           id: 1,
//           disabled: false,
//         },
//       ]}
//       titulo={"Mas Opciones"}
//     />
//     <BarraTablas
//       search={search}
//       setsearch={setsearch}
//       funcion={handleSearch}
//       buscando={buscando}
//       setbuscando={setbuscando}
//       LabelBuscador="Buscar por todos los campos"
//       funcionDefault={funcionDefault}
//       ocultarMigasDePan={idPer_frompersonas}
//       botones={[
//         {
//           tooltip: "Agregar",
//           texto: "Agregar",
//           funcion: () => {
//             setopen(true);
//           },
//           disabled: false,
//           Icon: Add,
//           color: "primary",
//           id: 1,
//           ocultar: true,
//           tipo: "icono",
//           variante: "contained",
//           size: "medium",
//           sx: { marginRight: ".3rem" },
//         },
//         {
//           tooltip: "Agregar",
//           texto: "Agregar",
//           funcion: () => {
//             if (!tienePermiso("agregar")) {
//               return alertaPermiso("agregar");
//             }
//             setopen(true);
//           },
//           disabled: false,
//           Icon: Add,
//           color: "primary",
//           id: 2,
//           ocultar: false,
//           tipo: "boton",
//           variante: "contained",
//           size: "medium",
//           sx: {},
//         },
//         {
//           tooltip: "Agregar",
//           texto: "",
//           funcion: () => {
//             setopenMB(true);
//           },
//           disabled: false,
//           Icon: Search,
//           color: "secondary",
//           id: 2,
//           ocultar: false,
//           tipo: "icono",
//           variante: "contained",
//           size: "medium",
//           sx: {},
//         },
//       ]}
//     />
//     <ModalB
//       defaultFullBuscador={defaultFullBuscador}
//       openMB={openMB}
//       setopenMB={setopenMB}
//       titulo={"Busqueda avanzada (Actividades)"}
//       fullBuscador={fullBuscador}
//       setfullBuscador={setfullBuscador}
//       arrayProps={[...columns]}
//       handleChange={handleChange}
//       funcionB={funcionB}
//       buscando={buscando}
//       funcionDefault={funcionDefault}
//     />
//     <Box
//       display="flex"
//       justifyContent="space-between"
//       alignItems=" stretch"
//       width="100%"
//     >
//       <Box>
//         {[].map((itemEstado) => (
//           <Button
//             size="small"
//             variant={estadoRequest === itemEstado ? "contained" : null}
//             disabled={cargando}
//             onClick={async () => {
//               setcargando(true);
//               await obtenerState(
//                 rowsPerPage,
//                 0,
//                 "",
//                 input.id,
//                 orden,
//                 JSON.stringify(fullBuscador),
//                 rucempresa,
//                 itemEstado
//               );

//               setPage(0);
//               setestadoRequest(itemEstado);
//               setcargando(false);
//             }}
//             disableElevation
//             style={{ padding: ".5rem", borderRadius: "15px 15px  0px 0px" }}
//             color="primary"
//           >
//             {itemEstado}
//           </Button>
//         ))}
//       </Box>
//       <Button
//         size="small"
//         variant={eliminado ? "contained" : "outlined"}
//         disabled={cargando}
//         onClick={async () => {
//           setcargando(true);
//           await obtenerState(
//             rowsPerPage,
//             0,
//             "",
//             input.id,
//             orden,
//             JSON.stringify(fullBuscador),
//             rucempresa,
//             estadoRequest,
//             !eliminado
//           );

//           setPage(0);
//           seteliminado(!eliminado);
//           setcargando(false);
//         }}
//         disableElevation
//         style={{ padding: ".5rem", borderRadius: "15px 15px  0px 0px" }}
//         color="error"
//       >
//         Eliminado
//       </Button>
//     </Box>
//     <Divider />
//     <Tabla
//       //PAGINACION Y BUSQUEDA
//       page={page}
//       setPage={setPage}
//       rowsPerPage={rowsPerPage}
//       setRowsPerPage={setRowsPerPage}
//       setopen={setopen}
//       search={search}
//       input={input}
//       orden={orden}
//       setinput={setinput}
//       setorden={setorden}
//       cargando={cargando}
//       setcargando={setcargando}
//       fullBuscador={fullBuscador}
//       //ESTADO
//       rows={rows}
//       columns={columns}
//       pagination={pagination}
//       getDataState={getDataState}
//       obtenerState={obtenerState}
//       addRowsState={addRowsState}
//       remplazarRowsState={remplazarRowsState}
//       changeObjetoActivoState={changeObjetoActivoState}
//       seteditar={seteditar}
//       arrayExport={arrayExport}
//       setarrayExport={setarrayExport}
//       socket={socket}
//       campoExport={campoExport}
//       estadoRequest={estadoRequest}
//       tabla={tabla}
//     />
//     {socket.current && (
//       <Modal
//         editar={editar}
//         seteditar={seteditar}
//         setopen={setopen}
//         open={open}
//         ObjectoActivo={ObjectoActivo}
//         changeObjetoActivoState={changeObjetoActivoState}
//         socket={socket}
//       />
//     )}
